import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// ─── Auth Store ──────────────────────────────────────────────────────────────
export const useAuthStore = create((set) => ({
  user: null,
  userRole: null,
  userData: null,
  loading: true,
  setUser: (user) => set({ user }),
  setUserRole: (userRole) => set({ userRole }),
  setUserData: (userData) => set({ userData }),
  setLoading: (loading) => set({ loading }),
  clearUser: () => set({ user: null, userRole: null, userData: null })
}));

// ─── Cart Store ──────────────────────────────────────────────────────────────
export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      
      addItem: (product, quantity = 1, selectedVariation = null) => {
        const items = get().items;
        const key = `${product.id}_${selectedVariation}`;
        const existing = items.find(i => `${i.id}_${i.selectedVariation}` === key);
        
        if (existing) {
          set({
            items: items.map(i =>
              `${i.id}_${i.selectedVariation}` === key
                ? { ...i, quantity: i.quantity + quantity }
                : i
            )
          });
        } else {
          set({ items: [...items, { ...product, quantity, selectedVariation }] });
        }
      },
      
      removeItem: (id, selectedVariation) => {
        set({ items: get().items.filter(i => !(i.id === id && i.selectedVariation === selectedVariation)) });
      },
      
      updateQuantity: (id, selectedVariation, quantity) => {
        if (quantity < 1) return;
        set({
          items: get().items.map(i =>
            i.id === id && i.selectedVariation === selectedVariation ? { ...i, quantity } : i
          )
        });
      },
      
      clearCart: () => set({ items: [] }),
      
      getTotal: () => get().items.reduce((a, b) => a + b.price * b.quantity, 0),
      getCount: () => get().items.reduce((a, b) => a + b.quantity, 0)
    }),
    { name: 'sitsmart-cart' }
  )
);

// ─── Wishlist Store ───────────────────────────────────────────────────────────
export const useWishlistStore = create(
  persist(
    (set, get) => ({
      items: [],
      
      toggle: (product) => {
        const items = get().items;
        const exists = items.find(i => i.id === product.id);
        if (exists) {
          set({ items: items.filter(i => i.id !== product.id) });
        } else {
          set({ items: [...items, product] });
        }
      },
      
      isWishlisted: (id) => get().items.some(i => i.id === id),
      
      clearWishlist: () => set({ items: [] })
    }),
    { name: 'sitsmart-wishlist' }
  )
);

// ─── UI Store ─────────────────────────────────────────────────────────────────
export const useUIStore = create((set) => ({
  cartOpen: false,
  searchOpen: false,
  mobileMenuOpen: false,
  setCartOpen: (cartOpen) => set({ cartOpen }),
  setSearchOpen: (searchOpen) => set({ searchOpen }),
  setMobileMenuOpen: (mobileMenuOpen) => set({ mobileMenuOpen })
}));
